import StudentTables from '@/components/common/tables/students-table/StudentsTable';
import { useTranslation } from 'react-i18next';

const Activity = () => {
  const { t } = useTranslation();
  // const currentYear = new Date().getFullYear();
  return (
    <section className="w-full">
      <StudentTables />
    </section>
  );
};

export default Activity;
